/**
 * Group membership shape as returned by `/users/logged_in_user/`
 * (`UserRelatedSerializer`, `users/serializers.py`): `groups` is a
 * `SlugRelatedField(slug_field='name')`, i.e. a plain array of group NAME
 * strings. The `{ name }` object form is accepted defensively in case some
 * other caller ever hands this a richer group shape.
 */
export type InternalOrdersManagerGroup = string | { name?: string | null } | null | undefined;

export interface InternalOrdersManagerUser {
	is_superuser?: boolean;
	groups?: InternalOrdersManagerGroup[] | null;
}

// Case-insensitive: the group name drifts across environments ("Shop
// Manager" singular vs "Shop Managers" plural) -- accept both.
const SHOP_MANAGER_GROUP_RE = /^shop managers?$/i;

/**
 * True when `user` may perform internal-order mutations (create, finalize,
 * upload internal files, re-run analysis): a member of the Shop Manager(s)
 * group, or a superuser. Mirrors the backend's InInternalOrdersManageGroup
 * permission so the UI never offers a control the API will 403 on.
 */
export const isInternalOrdersManager = (
	user: InternalOrdersManagerUser | null | undefined,
): boolean =>
	!!user &&
	(user.is_superuser === true ||
		(user.groups ?? []).some((g) =>
			SHOP_MANAGER_GROUP_RE.test(typeof g === 'string' ? g : (g?.name ?? '')),
		));

export default isInternalOrdersManager;
